<h2 mat-dialog-title>Configurar grabación</h2>

<mat-dialog-content>
  <mat-radio-group class="mode-list" [(ngModel)]="recording_mode">
    <mat-radio-button value="audio">Solo audio</mat-radio-button>
    <mat-radio-button value="screen">Pantalla (vídeo)</mat-radio-button>
  </mat-radio-group>

  @if (recording_mode === 'audio') {
    <p class="dialog-description">Selecciona el micrófono que quieres grabar.</p>

    <mat-form-field class="full-width-field">
      <mat-label>Micrófono</mat-label>
      <mat-select [(ngModel)]="microphone_device_id" [disabled]="is_loading_microphones || microphone_device_options.length === 0">
        @for (device of microphone_device_options; track device.device_id) {
          <mat-option [value]="device.device_id">{{ device.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (!is_loading_microphones && microphone_device_options.length === 0) {
      <p class="dialog-warning">No se encontró ningún micrófono disponible.</p>
    }
    @if (microphone_permission_message !== null) {
      <p class="dialog-warning">{{ microphone_permission_message }}</p>
    }
  } @else {
    @if (data.is_electron) {
      <p class="dialog-description">Elige la pantalla que quieres grabar.</p>

      @if (is_loading_display_sources) {
        <p class="dialog-description">Cargando pantallas…</p>
      } @else if (display_sources.length === 0) {
        <p class="dialog-warning">No se encontró ninguna pantalla disponible.</p>
      } @else {
        <mat-radio-group class="source-list" [(ngModel)]="selected_display_source_id">
          @for (source of display_sources; track source.id) {
            <mat-radio-button class="source-option" [value]="source.id">
              <div class="source-option-content">
                @if (source.thumbnail_data_url) {
                  <img class="source-thumbnail" [src]="source.thumbnail_data_url" [alt]="source.name" />
                }
                <span class="source-name">{{ source.name }}</span>
              </div>
            </mat-radio-button>
          }
        </mat-radio-group>
      }
      @if (screen_permission_message !== null) {
        <p class="dialog-warning">{{ screen_permission_message }}</p>
      }

      @if (supports_system_audio) {
        <mat-checkbox class="system-audio-checkbox" [(ngModel)]="include_system_audio"> Compartir audio del sistema </mat-checkbox>
      }
    } @else {
      <div class="browser-picker-notice">
        <mat-icon>info</mat-icon>
        <p>
          Al pulsar <strong>Grabar</strong>, Chrome abrirá su propio diálogo para elegir pantalla, ventana o pestaña. Activa allí la opción
          de <strong>compartir audio del sistema</strong> si quieres capturar el sonido.
        </p>
      </div>
    }

    <mat-checkbox class="include-mic-checkbox" [(ngModel)]="include_microphone_with_screen"> Incluir micrófono </mat-checkbox>

    @if (include_microphone_with_screen) {
      <mat-form-field class="full-width-field">
        <mat-label>Micrófono</mat-label>
        <mat-select [(ngModel)]="microphone_device_id" [disabled]="is_loading_microphones || microphone_device_options.length === 0">
          @for (device of microphone_device_options; track device.device_id) {
            <mat-option [value]="device.device_id">{{ device.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="!can_confirm()" (click)="confirm()">Grabar</button>
</mat-dialog-actions>
